<template>
  <svg
    :class="className"
    style="--text-color: var(--color-text-primary)"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <path
      d="M38.0186 7L38.3193 7.39355L51.1904 24.2773V27.4619H32.9043V9H13V55H52V57H11V7H38.0186ZM34.9043 25.4619H49.1904V24.9521L37.0283 9H34.9043V25.4619Z"
      fill="#6F6F71"
    />
    <text
      v-if="text.length && text.length < 4"
      x="18"
      y="50"
      style="font-family: 'Graphik'; font-size: 16px; fill: #6400e7; font-weight: 500"
    >
      {{ text }}
    </text>
  </svg>
</template>

<script setup>
  const { className } = defineProps({
    className: {
      default: 'file-icon',
      type: String,
    },
    text: {
      default: '',
      type: String,
    },
  });
</script>
